import { BaseDto } from "../base/baseDto.model";

export class TipoPropiedadDto extends BaseDto{
}
